$(document).ready(function () {
  function updatePrices() {
    var total = 0;
    var anyChecked = false;

    $(".custom_input_check").each(function () {
      if ($(this).prop("checked")) {
        var price = $(this).data("price");
        total += Number(price);
        anyChecked = true;
      }
    });

    var disc = $(".custom_items_wrapper,.products-inner-container").data("peroff");
    var discountPrice = total - (Number(disc) * total) / 100;

    if (anyChecked) {
      var price = Math.round(total);
      var discount = Math.round(discountPrice);
      $(".custom_items_compare_price").text("$" + price);
      $(".custom_items_total_price").text("$" + discount);
      console.log(price + '>' + discount);
      if (price > discount) {
        $(".custom_items_compare_price").show();
      } else if(discount <= price) {
        $(".custom_items_compare_price").hide();
      }

      $(".custom_items_total_price").show();
      $(".custom_item_atc_btn,.dyanamic-product-item-atc-btn").removeAttr("disabled");
    } else {
      $(".custom_items_compare_price, .custom_items_total_price").hide();
      $(".custom_item_atc_btn,.dyanamic-product-item-atc-btn").attr("disabled", true);
    }
  }

  updatePrices();

  $(".custom_input_check").on("change", function () {
    updatePrices();
  });

  $(".custom_item_atc_btn,.dyanamic-product-item-atc-btn").on("click", function (e) {
    e.preventDefault();

    var button = $(this);
    var wrapper = button.parents(".custom_items_wrapper,.products-inner-container");

    var total = 0;

    wrapper.find(".custom_item,.dynamic-product").each(function () {
      var checkbox = $(this).find(".custom_input_check");
      if (checkbox.prop("checked")) {
        total =
          total +
          Number(checkbox.data("price")) *
            Number(checkbox.val());
      }
    });

    var disc = wrapper.data("peroff");
    total = total - (Number(disc) * total) / 100;
    var inttotal = Math.round(total);

    var loader = button.find(".loading-overlay__spinner");
    var textel = button.find("span");
    loader.removeClass("hidden");
    textel.css("opacity", "0");
    var variantId = $('.defaultbuylook[data-varprice="' + inttotal + '"]').data("varid");
    if (!variantId) {
      loader.addClass("hidden");
      textel.css("opacity", "1");
      alert("Variant not found for this combination.");
      return;
    }

    var properties = {};
    var product_name = "";
    var product_image = "";
    var product_variant_name = "";
    var product_variant_id = "";
    var product_quantity = 1;
    var pids = '';
    var pqty = '';
    let included = "";

    wrapper.find(".custom_item, .dynamic-product").each(function (index) {
      const $item = $(this);
      const checkbox = $item.find(".custom_input_check");

      if (!checkbox.prop("checked")) return;

      product_name = (checkbox.attr("selected-title") ?? "").toString().trim();
      product_variant_name = (checkbox.attr("variant-title") ?? "").toString().trim();
      product_variant_id = (checkbox.attr("variant-id") ?? "").toString().trim();
      product_image = (checkbox.attr("variant-image") ?? "").toString().trim();
      pids += pids ? `,${product_variant_id}` : product_variant_id;
      pqty += pqty ? `,${product_quantity}` : product_quantity;

      const line = `${product_name} - ${product_variant_name}`;
      included += included ? `,\r\n${line}` : line;

      const i = index + 1;

      properties["_bundle"] = true;
      // properties[`_bundle_${i}_title`] = product_name;
      // properties[`_bundle_${i}_image`] = product_image;
      // properties[`_bundle_${i}_variant_title`] = product_variant_name;
      // properties[`_bundle_${i}_variant_id`] = product_variant_id;
      properties[`_prqty`] = pqty;
      properties[`_prids`] = pids;
      properties[`Included`] = included;
    });


    if (!product_variant_name) {
      loader.addClass("hidden");
      textel.css("opacity", "1");
      alert("Please select at least one item.");
      return;
    }



    var cartElement =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    Object.keys(properties).forEach(function (key) {
      formData.append("properties[" + key + "]", properties[key]);
    });

    if (cartElement && typeof cartElement.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cartElement
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
      );
      formData.append("sections_url", window.location.pathname);
      if (typeof cartElement.setActiveElement === "function") {
        cartElement.setActiveElement(document.activeElement);
      }
    }

    var config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error("Cart error:", response.description || response.message);
          return;
        }

        if (!cartElement) {
          if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          } else {
            window.location = "/cart";
          }
          return;
        }

        if (typeof cartElement.renderContents === "function") {
          cartElement.renderContents(response);
        }
      })
      .catch(function (error) {
        console.error("Add to cart error:", error);
      })
      .finally(function () {
        loader.addClass("hidden");
        textel.css("opacity", "1");
      });
  });

// Article page 
  $(".dynamic-bundle-atc").on("click", function (e) {
    e.preventDefault();

    var button = $(this);
    var wrapper = button.parents(".dynamic-product_list").find(".products-inner-container");
    var total = 0;
    wrapper.find(".dynamic-product").each(function () {
      var checkbox = $(this).find(".custom_input_check");
   
        total =
          total +
          Number(checkbox.data("price")) *
            Number(checkbox.val());
    });

    var disc = wrapper.data("peroff");
    total = total - (Number(disc) * total) / 100;
    var inttotal = Math.round(total);

    console.log('price is' + inttotal)

    var loader = button.find(".loading-overlay__spinner");
    var textel = button.find("span");
    loader.removeClass("hidden");
    textel.css("opacity", "0");
    var variantId = $('.defaultbuylook[data-varprice="' + inttotal + '"]').data("varid");
    if (!variantId) {
      loader.addClass("hidden");
      textel.css("opacity", "1");
      alert("Variant not found for this combination.");
      return;
    }

    var properties = {};
    var product_name = "";
    var product_image = "";
    var product_variant_name = "";
    var product_variant_id = "";
    var pids = '';
    var pqty = '';
    var product_quantity = 1;
    let included = "";

    wrapper.find(".custom_item,.dynamic-product").each(function(index){
      const $item = $(this).find('.custom_input_check');


      product_name = ($item.attr("selected-title") ?? "").toString().trim();
      product_variant_name = ($item.attr("variant-title") ?? "").toString().trim();
      product_image = ($item.attr("variant-image") ?? "").toString().trim();
      product_variant_id = ($item.attr("variant-id") ?? "").toString().trim();
      pids += pids ? `,${product_variant_id}` :product_variant_id ;
      pqty += pqty ? `,${product_quantity}`:product_quantity;

      const line = `${product_name} - ${product_variant_name}`;
      included += included ? `,\r\n${line}` : line;

      const i = index + 1;

      properties["_bundle"] = true;
      // properties[`_bundle_${i}_title`] = product_name;
      // properties[`_bundle_${i}_image`] = product_image;
      // properties[`_bundle_${i}_variant_title`] = product_variant_name;
      // properties[`_bundle_${i}_variant_id`] = product_variant_id;
      properties[`_prids`] = pids;
      properties[`_prqty`] = pqty;
      properties[`Included`] = included;
    });

    var cartElement =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    Object.keys(properties).forEach(function (key) {
      formData.append("properties[" + key + "]", properties[key]);
      console.log('key' + key + 'value' + properties[key]);
    });

    if (cartElement && typeof cartElement.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cartElement
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
      );
      formData.append("sections_url", window.location.pathname);
      if (typeof cartElement.setActiveElement === "function") {
        cartElement.setActiveElement(document.activeElement);
      }
    }

    var config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error("Cart error:", response.description || response.message);
          return;
        }

        if (!cartElement) {
          if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          } else {
            window.location = "/cart";
          }
          return;
        }

        if (typeof cartElement.renderContents === "function") {
          cartElement.renderContents(response);
        }
      })
      .catch(function (error) {
        console.error("Add to cart error:", error);
      })
      .finally(function () {
        loader.addClass("hidden");
        textel.css("opacity", "1");
      });
  });

    $(".dynamic-bundle-button-blog .bulk-add-cart").on("click", function (e) {
    e.preventDefault();
    var button = $(this);
    var wrapper = button.parents(".blog-articles").find(".product-card-new");
    var total = 0;
    wrapper.find(".dynamic-product").each(function () {
      var checkbox = $(this).find(".quantity__input");
   
        total =
          total +
          Number(checkbox.data("price")) *
            Number(checkbox.val());
    });

    var disc = wrapper.data("peroff");
    total = total - (Number(disc) * total) / 100;
    var inttotal = Math.round(total);

    console.log('price is'  + inttotal)

    var loader = button.find(".loading-overlay__spinner");
    var textel = button.find("span");
    loader.removeClass("hidden");
    textel.css("opacity", "0");
    var variantId = $('.defaultbuylook[data-varprice="' + inttotal + '"]').data("varid");
    console.log('variant ID is' + variantId + 'total amount' + inttotal );
    if (!variantId) {
      loader.addClass("hidden");
      textel.css("opacity", "1");
      alert("Variant not found for this combination again.");
      return;
    }

    var properties = {};
    var product_name = "";
    var product_image = "";
    var product_variant_name = "";
    var product_variant_id = "";
    var pids = '';
    var pqty = '';
    var product_quantity = 1;
    let included = "";

    wrapper.find(".dynamic-product").each(function(index){
      const $item = $(this).find('.quantity__input');
      product_name = ($item.attr("selected-title") ?? "").toString().trim();
      product_variant_name = ($item.attr("variant-title") ?? "").toString().trim();
      product_image = ($item.attr("variant-image") ?? "").toString().trim();
      product_variant_id = ($item.attr("variant-id") ?? "").toString().trim();

      pids += pids ? `,${product_variant_id}` :product_variant_id ;
      pqty += pqty ? `,${product_quantity}`:product_quantity;

      const line = `${product_name} - ${product_variant_name}`;
      included += included ? `,\r\n${line}` : line;

      const i = index + 1;
      console.log('product title' + product_name + 'product image' + product_image + 'variant Image' + product_variant_name);
      properties["_bundle"] = true;
      // properties[`_bundle_${i}_title`] = product_name;
      // properties[`_bundle_${i}_image`] = product_image;
      // properties[`_bundle_${i}_variant_title`] = product_variant_name;
      // properties[`_bundle_${i}_variant_id`] = product_variant_id;
      properties[`_prqty`] = pqty; 
      properties[`_prids`] = pids;
      properties[`Included`] = included;
    });

    var cartElement =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

    var formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    Object.keys(properties).forEach(function (key) {
      formData.append("properties[" + key + "]", properties[key]);
      console.log('key' + key + 'value' + properties[key]);
    });

    if (cartElement && typeof cartElement.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cartElement
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
      );
      formData.append("sections_url", window.location.pathname);
      if (typeof cartElement.setActiveElement === "function") {
        cartElement.setActiveElement(document.activeElement);
      }
    }

    var config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error("Cart error:", response.description || response.message);
          return;
        }

        if (!cartElement) {
          if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          } else {
            window.location = "/cart";
          }
          return;
        }

        if (typeof cartElement.renderContents === "function") {
          cartElement.renderContents(response);
        }
      })
      .catch(function (error) {
        console.error("Add to cart error:", error);
      })
      .finally(function () {
        loader.addClass("hidden");
        textel.css("opacity", "1");
      });
  });

});

$(function () {
  const $bundles = $('.custom-bundle-products');
  const $submit  = $('.product-form__submit');

  function validateBundles() {
    let allValid = true;

    $bundles.each(function () {
      const $proitem = $(this);
      const variantTitle = ($proitem.attr('variant-title') || '').trim();

      if (!variantTitle) {
        allValid = false;
        $proitem.find('.selected-variants').css('border', '1px solid #ff0000');
      } else {
        $proitem.find('.selected-variants').css('border', '');
      }
    });

    $submit.prop('disabled', !allValid);
    $submit.attr('aria-disabled', !allValid); // helpful for Shopify themes/accessibility
    return allValid;
  }

  // 1) Run on load (initial state)
  if ($bundles.length) validateBundles();

  // 2) Bind per-bundle swatch click
  $bundles.each(function () {
    const proitem = $(this);

    proitem.on('click', '.product-swatch__label', function (e) {
      e.preventDefault();

      const dataname  = $(this).data('title-name');
      const dataid    = $(this).data('id');
      const dataimage = $(this).data('bg-image');

      proitem.find('.product-swatch__label').removeClass('active');
      $(this).addClass('active');

      proitem.find('.selected-variants-label').html(`Select Shade: ${dataname}`);

      proitem.find('.custom-bundle-products-variants').slideUp();
      proitem.find('.arrow').removeClass('active');

      proitem.attr('variant-title', dataname);
      proitem.attr('variant-image', dataimage);
      proitem.attr('data-selected-variant', dataid); // make it an attribute if you want Liquid to read later
      proitem.data('selected-variant', dataid);       // keep your JS access too

      // Validate ALL bundles after every selection
      validateBundles();
    });
  });

  // // 3) Dropdown toggle (your existing logic, unchanged)
  // $('.selected-variants').click(function (e) {
  //   e.stopPropagation();
  //   const parent = $(this).closest('.custom-bundle-products');
  //   const variantsBox = parent.find('.custom-bundle-products-variants');
  //   const arrow = $(this).find('.arrow');

  //   $('.custom-bundle-products-variants').not(variantsBox).slideUp();
  //   $('.selected-variants .arrow').not(arrow).removeClass('active');

  //   variantsBox.slideToggle();
  //   arrow.toggleClass('active');
  // });

  // // Optional: click outside closes all
  // $(document).on('click', function () {
  //   $('.custom-bundle-products-variants').slideUp();
  //   $('.selected-variants .arrow').removeClass('active');
  // });
});

$(document).on('click', '.drop_icon', function () {
  const $container = $(this).closest('.product-swatch__container');
  const $swatch = $container.find('.hidden_swatch');
  const isOpen = $swatch.is(':visible');

  // Close all others
  $('.hidden_swatch').hide();
  $('.drop_icon').removeClass('rotate');

  // Toggle current
  if (!isOpen) {
    $swatch.show();
    $(this).addClass('rotate');
  }
});